/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'line_tool': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><clipPath id="svgicon_line_tool_a"><path pid="0" d="M0 0h24v24H0z"/></clipPath></defs><g clip-path="url(#svgicon_line_tool_a)"><path pid="1" data-name="Line 2" _fill="none" _stroke="#1d1d1d" stroke-linecap="round" stroke-width="3" d="M5.5 19.5l14-14"/></g>'
  }
})
